<template>
  <mdb-container>
    <div v-if="currentGroup && settings && settings.features.idCard && currentGroup.enableIdCard">
      <banner-small :group="currentGroup" title="ID Card"/>
      <mdb-card>
        <mdb-card-body class="align-items-center">
          <div v-if="isValid">
            <h5 class="text-warning">This QR code is valid for 5 minutes.</h5>
            <mdb-progress :value="progressValue"/>
          </div>
          <div v-if="!isValid">
            <mdb-btn @click="newCode">Generate New QR Code</mdb-btn>
          </div>
          <img :src="memberInfo.avatar" style="width:33%; float: left"/>
          <h3>{{ memberInfo.name }}</h3>
          <h4>Member Since {{ memberInfo.memberSince }}</h4>
          <h4 v-if="memberInfo.expirationDate">Expires {{ memberInfo.expirationDate }}</h4>
          <qrcode-vue v-if="memberInfo && memberInfo.qrCode && isValid" :value="memberInfo.qrCode" :size="300"
                      level="H"></qrcode-vue>
          <div class="text-info">A vendor or other entity can scan this QR Code for additional verification of your
            membership.
          </div>
        </mdb-card-body>
      </mdb-card>
    </div>
  </mdb-container>

</template>
<script>
import api from '../../services/groupsPlaceApi.js'
import bannerSmall from '../group/BannerSmall'
import moment from 'moment'
import QrcodeVue from 'qrcode.vue'

import {mdbBtn, mdbCard, mdbCardBody, mdbCardHeader, mdbContainer, mdbProgress} from 'mdbvue';

export default {
  name: "id-card",
  components: {
    mdbContainer,
    mdbBtn,
    mdbCard,
    mdbCardHeader,
    mdbProgress,
    mdbCardBody,
    bannerSmall,
    QrcodeVue
  },
  computed: {
    userDetails: function () {
      return this.$store.state.userDetails
    },
    currentGroup: function () {
      return this.$store.state.currentGroup
    },
    settings: function () {
      return this.$store.state.settings
    }
  },
  data() {
    return {
      memberInfo: {},
      timeLeft: 0,
      progressValue: 0,
      isValid: false
    }
  },
  mounted() {
    document.title = "ID Card"
    this.loadMember()
    api.trackGroupVisit(this.$route.params.id)
  },
  methods: {
    monitorTime() {
      if (!this.memberInfo) return
      this.timeLeft = (moment(this.memberInfo.codeExpiration)).diff(moment()) / 1000
      if (this.timeLeft <= 0) {
        this.progressValue = 0
        this.isValid = false
      }
      else {
        this.progressValue = (this.timeLeft / 300) * 100
        this.isValid = true
      }
      if (this.timeLeft > 0) {
        setTimeout(() => {
          this.monitorTime()
        }, 500)
      }
    },
    newCode() {
      this.loadMember()
    },
    loadMember() {
      api.get("/member/idCard/" + this.$route.params.id).then(
        (results) => {
          this.memberInfo = results.data
          this.monitorTime()
          this.progressValue = 100
          if (!this.currentGroup || this.currentGroup.id != this.memberInfo.groupId) {
            api.groupBasics(this.memberInfo.groupId, "member");
          }
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    }
  }
};

</script>
